import { useGate, useUnit } from 'effector-react'
import { useState } from 'react'
import {
  $debts,
  $optionsWallet,
  $optionsWalletWithArchive,
  $totalItems,
  $totalsDebts,
  DebtListGate,
  getDebtListFx,
} from 'src/pages/finSystem/debt/model'

export const useDebtListGate = () => useGate(DebtListGate)

export const useOptionsWallet = () => useUnit($optionsWallet)

export const useOptionsWalletWithArchive = () =>
  useUnit($optionsWalletWithArchive)

export const useDebtList = () => {
  const debts = useUnit($debts)
  const totalItems = useUnit($totalItems)
  const totalsDebts = useUnit($totalsDebts)
  const loading = useUnit(getDebtListFx.pending)

  return {
    debts,
    totalItems,
    totalsDebts,
    loading,
  }
}

export const useModalCreateDebt = (initialState = false) => {
  const [isOpenModalCreateDebt, setIsOpenModalCreateDebt] =
    useState(initialState)
  return {
    isOpenModalCreateDebt,
    setIsOpenModalCreateDebt,
  }
}
